import rvbRelatedArticles from './rvb-related-articles';

export const SECTION_NAMES = {
  TOOL_LINK_CARDS: 'rent_vs_buy_tool_card',
};

export const IMPRESSION_TRACKING_NAMES = {
  TOOL_LINK_CARDS: 'rent_vs_buy_tool_card',
};

export const SECTION_POSITION = {
  TOOL_LINK_CARDS: 4,
};

export const LEGACY_FIELD_NAMES = {
  LOCATION: 'LocationAutoComplete',
  PURCHASE_PRICE: 'purchasePrice',
  DOWN_PAYMENT: 'downPayment',
  DOWN_PAYMENT_PERCENT: 'downPaymentPercent',
  ANNUAL_INTEREST_RATE: 'interest_controlpanel_increment',
  LOAN_TERM: 'amortization_controlpanel_increment',
  MONTHLY_RENT: 'rentalPrice_controlpanel_input',
  PROPERTY_TAX_RATE: 'propertyTaxRate_controlpanel_increment',
  HOA_DUES: 'hoaDues_controlpanel_input',
  HOME_INSURANCE: 'homeInsurance_controlpanel_increment',
  MAINTAINANCE_FEE: 'maintainanceFees_controlpanel_increment',
  RENOVATION_FEES: 'renovationFees_controlpanel_increment',
  INCOME_TAX_RATE: 'incomeTaxRate_controlpanel_increment',
  RENTERS_INSURANCE: 'rentersInsurance_controlpanel_increment',
  BUYING_COSTS: 'buyingCosts_controlpanel_increment',
  SELLING_COSTS: 'sellingCosts_controlpanel_increment',
  RENT_SECURITY_DEPOSIT: 'securityDeposit_controlpanel_increment',
  HOME_APPRECIATION: 'homeAppreciation_controlpanel_increment',
  RENT_APPRECIATION: 'rentAppreciation_controlpanel_increment',
  GENERAL_INFLATION: 'inflationRate_controlpanel_increment',
  ANNUAL_RETURN_CASH: 'discountRate_controlpanel_increment',
  TAX_FILING_STATUS: 'taxFilingStatus',
  INCOME: 'householdIncome_controlpanel_input',
  CAPITAL_GAINS_TAX_RATE: 'capitalGainsTaxRate_controlpanel_increment',
};

export const RELATED_ARTICLES = {
  entityName: 'rent_vs_buy_related_articles',
  sectionName: 'rent_vs_buy_related_articles',
  sectionPosition: 3,
  articles: rvbRelatedArticles,
};
